import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem("admin_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

// Public API
export const publicApi = {
  getProducts: () => api.get("/products"),
  getTestimonials: () => api.get("/testimonials"),
  getSiteContent: () => api.get("/site-content"),
  sendMessage: (data) => api.post("/messages", data),
};

// Auth API
export const authApi = {
  login: (email, password) => api.post("/admin/login", { email, password }),
  getMe: () => api.get("/admin/me"),
  exchangeGoogleSession: (session_id) => api.post("/admin/auth/session", { session_id }),
  logout: () => api.post("/admin/auth/logout"),
};

// Admin API
export const adminApi = {
  // Products
  createProduct: (data) => api.post("/admin/products", data),
  updateProduct: (id, data) => api.put(`/admin/products/${id}`, data),
  deleteProduct: (id) => api.delete(`/admin/products/${id}`),
  // Testimonials
  createTestimonial: (data) => api.post("/admin/testimonials", data),
  updateTestimonial: (id, data) => api.put(`/admin/testimonials/${id}`, data),
  deleteTestimonial: (id) => api.delete(`/admin/testimonials/${id}`),
  // Messages
  getMessages: () => api.get("/admin/messages"),
  markMessageRead: (id) => api.put(`/admin/messages/${id}/read`),
  deleteMessage: (id) => api.delete(`/admin/messages/${id}`),
  // Site Content
  updateSiteContent: (data) => api.put("/admin/site-content", data),
  // Analytics
  getAnalytics: () => api.get("/admin/analytics"),
  // Upload
  uploadImage: (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post("/admin/upload-image", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export default api;
